export default "__VITE_ASSET__DuSSis0S__"